import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Wrapper from "./referralForm.styles";
import environmentSettings from "../../../../constants/environmentSettings";
import { useDispatch, useSelector } from "react-redux";
import actions from "@src/redux/leadMarketIFrame/actions";

const initLeadMarketReferralForm = (formConfig, token, targetExists) => {
  if (!targetExists) return;

  const {
    scriptId,
  } = formConfig;
  
  const mlmLoaderElement = document.getElementById(scriptId);

  const leadMarketConfig = {
    aff: environmentSettings.leadMarketAffiliateCode,
    mode: "embedded",
    "hide-tc": "",
    test_sale_outcome:
      environmentSettings.leadMarketMode !== "production" ? 4 : 1,
  };

  const config = Object.assign(leadMarketConfig, {
    ref: "",
    tok : token,    
  });

  const event = new CustomEvent("mlm.init", { detail: config });
  mlmLoaderElement.dispatchEvent(event);
  console.log("Lead Market Referral Form initialized with config:", config);
};

const ReferralForm = (props) => {
  const dispatch = useDispatch();
  const { companyName } = environmentSettings;
  const scriptConfig = {
    scriptId: "mlm-loader-1-target",
    dataTargetId: "mlm-loader-1",
  };
  const { token, isSubmitting, submissionFailed } = useSelector((state) => state.LeadMarketIFrame);
  const urlParams = new URLSearchParams(window.location.search);
    let accountId =
    urlParams && urlParams.get("id")
      ? urlParams.get("id").split("loanapplication-")[1] ?? urlParams.get("id")
      : "";
  const { values } = props;
  const [isFormRendered, setIsFormRendered] = useState(false);
  const [targetExists, setTargetExists] = useState(!!(document.getElementById(scriptConfig.dataTargetId)));

  useEffect(() => {
    const target = document.getElementById("mlm-loader-1");
    if (target) {
      setTargetExists(true);
      return;
    }

    const observer = new MutationObserver(() => {
      const target = document.getElementById("mlm-loader-1");
      if (target) {
        setTargetExists(true);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);


  useEffect(() => {
    if (!targetExists) return;
    let script = !!(document.getElementById(scriptConfig.scriptId));

    if (script) {
      return;
    }

    script = document.createElement("script");
    script.setAttribute("id", scriptConfig.scriptId);
    script.setAttribute("data-target", scriptConfig.dataTargetId);
    script.setAttribute("data-include-url-param", "true");
    script.setAttribute("data-defer", "true");
    script.setAttribute("data-full-screen", "true");
    script.setAttribute(
      "src",
      `https://static.creditsense.com.au/iframe/mlm-loader.js?mode=embedded`
    );
    document.body.appendChild(script);
  }, [targetExists]);

  useEffect(() => {
    dispatch(actions.submitLeadMarket(accountId));
  }, [accountId]);

  useEffect(() => {
    const initForm = () => {
      const formConfig = Object.assign({}, scriptConfig, { values });
      initLeadMarketReferralForm(formConfig, token, targetExists);
    };

    if (!accountId) {
      const initTimer = setTimeout(() => {
        initForm();
      }, 1100);
      return () => clearTimeout(initTimer);
    }

    initForm();
  }, [token, isSubmitting, submissionFailed, targetExists]);

   useEffect(() => {
     const referralForm = document.getElementsByClassName("referral-form");
       if (referralForm[0].firstElementChild) {
         setIsFormRendered(true);
       } else {
         setIsFormRendered(false);
       }
   }, [targetExists]);

   useEffect(() => {
     if (!isFormRendered) return;

     const referralForm = document.getElementsByClassName("referral-form");
     if (referralForm.length > 0 && referralForm[0].firstElementChild) {
       referralForm[0].firstElementChild.setAttribute(
         "id",
         "referral-form-iframe"
       );
     }
   }, [isFormRendered, targetExists]);

  return (
    <Wrapper>
      <div className="referral-form" id="mlm-loader-1" />
      <div className="referral-form-end-padding" />
      <div className="referral-form-disclaimer">
        {companyName} may receive a payment or benefit from Lead Market
        Australia for this referral at no cost to you.
      </div>
    </Wrapper>
  );
};

ReferralForm.propTypes = {
  values: PropTypes.object,
};

export default ReferralForm;
